/* Fabric Alex global product cards v2 — presentation only; Shopify/Liquid keeps commerce authority. */
(function () {
  'use strict';

  var CARD_SELECTOR = '.fa-product-card.product-item--vertical';
  var SWATCH_SPEED_PX_PER_SECOND = 20;
  var mobile = window.matchMedia('(max-width: 640px)');
  var lang = (document.documentElement.lang || '').toLowerCase();
  var unitLabel = lang.indexOf('bg') === 0 ? '/метър' : '/meter';
  var viewLabel = lang.indexOf('bg') === 0 ? 'Виж продукта' : 'View product';
  var visibilityObserver = null;
  var preloadObserver = null;
  var queuedCards = new Set();
  var flushScheduled = false;
  var resizeFrame = null;

  function isCard(node) {
    return !!(node && node.nodeType === 1 && node.matches && node.matches(CARD_SELECTOR));
  }

  function removeQuickView(card) {
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll('[data-secondary-action="open-quick-view"]'), function (button) {
      if (button.parentNode) button.parentNode.removeChild(button);
    });
  }

  function ensureBrand(card) {
    var info = card.querySelector('.product-item__info-inner');
    if (!info || info.querySelector('.fa-product-card__brand')) return;

    var brand = document.createElement('div');
    brand.className = 'fa-product-card__brand';
    brand.setAttribute('aria-hidden', 'true');
    brand.textContent = 'Fabric Alex';
    info.insertBefore(brand, info.firstChild);
  }

  function groupPriceAndUnit(card) {
    var priceList = card.querySelector('.product-item__price-list');
    if (!priceList) return;

    var unit = priceList.querySelector('.fa-product-card__price-unit');
    if (!unit) return;
    if (unit.textContent.trim() !== unitLabel) unit.textContent = unitLabel;

    var currentPrice = priceList.querySelector('.price:not(.price--compare)');
    if (!currentPrice) return;

    var group = priceList.querySelector('.fa-product-card__current-price');
    if (!group) {
      group = document.createElement('span');
      group.className = 'fa-product-card__current-price';
      priceList.insertBefore(group, currentPrice);
    }

    if (currentPrice.parentNode !== group) group.insertBefore(currentPrice, group.firstChild);
    if (unit.parentNode !== group) group.appendChild(unit);
  }

  function normalizeCta(card) {
    var action = card.querySelector('.product-item__action-list .product-item__action-button.button--primary');
    if (!action) return;

    if (action.tagName === 'A') {
      if (action.textContent.trim() !== viewLabel) action.textContent = viewLabel;
      action.setAttribute('data-fa-view-product', 'true');
      action.removeAttribute('data-fa-add-product');
      return;
    }

    if (action.matches('button[data-action="add-to-cart"]')) {
      action.setAttribute('data-fa-add-product', 'true');
      action.removeAttribute('data-fa-view-product');
    }
  }

  function nativeEntries(card) {
    var nativeList = card && card.querySelector('.product-item__swatch-list');
    if (!nativeList) return [];

    return Array.prototype.slice.call(nativeList.querySelectorAll('.color-swatch')).map(function (swatch) {
      var radio = swatch.querySelector('.color-swatch__radio');
      var label = swatch.querySelector('.color-swatch__item');
      if (!radio || !label || !radio.id) return null;
      return { radio: radio, label: label };
    }).filter(Boolean);
  }

  function signature(entries) {
    return entries.map(function (entry) { return entry.radio.id; }).join('|');
  }

  function createVisualSwatch(entry) {
    var shell = document.createElement('span');
    shell.className = 'fa-v8-swatch';

    var clone = entry.label.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('for', entry.radio.id);
    clone.setAttribute('data-fa-v8-input-id', entry.radio.id);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('tabindex', '-1');
    clone.classList.toggle('is-selected', !!entry.radio.checked);

    shell.appendChild(clone);
    return shell;
  }

  function createGroup(entries, extraClass) {
    var group = document.createElement('div');
    group.className = 'fa-v8-swatch-group' + (extraClass ? ' ' + extraClass : '');
    entries.forEach(function (entry) { group.appendChild(createVisualSwatch(entry)); });
    return group;
  }

  function setLoopSpeed(view) {
    if (!view || !view.classList.contains('fa-v8-swatch-view--loop')) return;
    var originalGroup = view.querySelector('.fa-v8-swatch-group--original');
    if (!originalGroup) return;

    var travelDistance = originalGroup.getBoundingClientRect().width || originalGroup.scrollWidth || 0;
    if (travelDistance <= 0) return;

    var duration = travelDistance / SWATCH_SPEED_PX_PER_SECOND;
    view.style.setProperty('--fa-v8-duration', duration.toFixed(2) + 's');
  }

  function refreshLoopSpeeds() {
    Array.prototype.forEach.call(document.querySelectorAll('.fa-v8-swatch-view--loop'), setLoopSpeed);
  }

  function getVisibilityObserver() {
    if (visibilityObserver || !('IntersectionObserver' in window)) return visibilityObserver;

    visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.target || !entry.target.classList) return;
        entry.target.classList.toggle('fa-v8-is-running', !!entry.isIntersecting);
      });
    }, { rootMargin: '90px 0px', threshold: .01 });

    return visibilityObserver;
  }

  function syncVisual(card) {
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll('.fa-v8-swatch-view [data-fa-v8-input-id]'), function (label) {
      var id = label.getAttribute('data-fa-v8-input-id');
      var radio = id ? document.getElementById(id) : null;
      label.classList.toggle('is-selected', !!(radio && radio.checked));
    });
  }

  function removeVisual(card) {
    if (!card) return;
    var oldView = card.querySelector('.fa-v8-swatch-view');
    if (oldView) {
      var observer = getVisibilityObserver();
      if (observer) {
        try { observer.unobserve(oldView); } catch (error) {}
      }
      if (oldView.parentNode) oldView.parentNode.removeChild(oldView);
    }
    card.classList.remove('fa-v8-has-swatches');
    card.removeAttribute('data-fa-v8-signature');
  }

  function buildVisualSwatches(card) {
    if (!mobile.matches || !card) return;

    var nativeList = card.querySelector('.product-item__swatch-list');
    if (!nativeList) {
      removeVisual(card);
      return;
    }

    var entries = nativeEntries(card);
    if (!entries.length) {
      removeVisual(card);
      return;
    }

    var nextSignature = signature(entries);
    var existing = card.querySelector('.fa-v8-swatch-view');
    if (existing && card.getAttribute('data-fa-v8-signature') === nextSignature) {
      syncVisual(card);
      setLoopSpeed(existing);
      return;
    }

    if (existing) removeVisual(card);

    var view = document.createElement('div');
    var looping = entries.length >= 4;
    view.className = 'fa-v8-swatch-view ' + (looping ? 'fa-v8-swatch-view--loop' : 'fa-v8-swatch-view--static');
    view.setAttribute('data-fa-v8-count', String(entries.length));
    view.setAttribute('aria-hidden', 'true');

    var track = document.createElement('div');
    track.className = 'fa-v8-swatch-track';
    track.appendChild(createGroup(entries, 'fa-v8-swatch-group--original'));

    if (looping) {
      track.appendChild(createGroup(entries, 'fa-v8-swatch-group--clone'));
    }

    view.appendChild(track);
    nativeList.parentNode.insertBefore(view, nativeList.nextSibling);
    if (looping) setLoopSpeed(view);
    card.classList.add('fa-v8-has-swatches');
    card.setAttribute('data-fa-v8-signature', nextSignature);
    syncVisual(card);

    var observer = getVisibilityObserver();
    if (observer) observer.observe(view);
    else view.classList.add('fa-v8-is-running');
  }

  function choosePreloadWidth(radio, card) {
    var desired = Math.ceil(Math.max(220, card.getBoundingClientRect().width * (window.devicePixelRatio || 1)));
    var widths = [];
    try { widths = JSON.parse(radio.getAttribute('data-image-widths') || '[]'); } catch (error) { widths = []; }
    widths = widths.map(function (value) { return parseInt(value, 10); }).filter(function (value) { return value > 0; }).sort(function (a,b) { return a - b; });
    if (!widths.length) return Math.min(600, desired);
    for (var i = 0; i < widths.length; i += 1) if (widths[i] >= desired) return widths[i];
    return widths[widths.length - 1];
  }

  function preloadRadioImage(radio, card) {
    if (!radio || radio.__faGlobalCardPreloaded) return;
    var url = radio.getAttribute('data-image-url');
    if (!url) return;
    url = url.replace(/\{width\}/g, String(choosePreloadWidth(radio, card)));
    radio.__faGlobalCardPreloaded = true;
    var image = new Image();
    image.decoding = 'async';
    image.src = url;
    radio.__faGlobalCardPreloadImage = image;
  }

  function preloadCard(card) {
    Array.prototype.forEach.call(card.querySelectorAll('.color-swatch__radio[data-image-url]'), function (radio) {
      if (!radio.checked) preloadRadioImage(radio, card);
    });
  }

  function schedulePreload(card) {
    if (!card || card.__faGlobalPreloadRegistered) return;
    card.__faGlobalPreloadRegistered = true;

    if ('IntersectionObserver' in window) {
      if (!preloadObserver) {
        preloadObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            preloadObserver.unobserve(entry.target);
            var run = function () { preloadCard(entry.target); };
            if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 450 });
            else window.setTimeout(run, 80);
          });
        }, { rootMargin: '280px 0px' });
      }
      preloadObserver.observe(card);
    }
  }

  function processCard(card, index) {
    if (!isCard(card)) return;
    removeQuickView(card);
    ensureBrand(card);
    groupPriceAndUnit(card);
    normalizeCta(card);
    buildVisualSwatches(card);
    schedulePreload(card);
    if (typeof index === 'number') card.style.setProperty('--fa-card-index', String(index));
    card.setAttribute('data-fa-card-system', 'v2');
  }

  function processAll() {
    Array.prototype.forEach.call(document.querySelectorAll(CARD_SELECTOR), function (card, index) { processCard(card, index); });
  }

  function queueCard(card) {
    if (!isCard(card)) return;
    queuedCards.add(card);
    if (flushScheduled) return;
    flushScheduled = true;
    window.requestAnimationFrame(function () {
      flushScheduled = false;
      var cards = Array.from(queuedCards);
      queuedCards.clear();
      cards.forEach(function (item, index) { processCard(item, index); });
    });
  }

  function queueFromNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (isCard(node)) queueCard(node);
    if (node.querySelectorAll) Array.prototype.forEach.call(node.querySelectorAll(CARD_SELECTOR), queueCard);
    if (node.closest) {
      var parentCard = node.closest(CARD_SELECTOR);
      if (parentCard) queueCard(parentCard);
    }
  }

  function pauseView(view, delay) {
    if (!view) return;
    view.classList.add('fa-v8-is-paused');
    window.clearTimeout(view.__faGlobalResumeTimer);
    view.__faGlobalResumeTimer = window.setTimeout(function () { view.classList.remove('fa-v8-is-paused'); }, delay || 1750);
  }

  processAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', processAll, { once: true });

  var mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], queueFromNode);
    });
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('pointerdown', function (event) {
    if (!event.target || !event.target.closest) return;

    var visualLabel = event.target.closest('.fa-v8-swatch-view .color-swatch__item');
    if (visualLabel) {
      var visualCard = visualLabel.closest(CARD_SELECTOR);
      pauseView(visualLabel.closest('.fa-v8-swatch-view'), 1750);
      var visualId = visualLabel.getAttribute('data-fa-v8-input-id') || visualLabel.getAttribute('for');
      var visualRadio = visualId ? document.getElementById(visualId) : null;
      if (visualCard && visualRadio) preloadRadioImage(visualRadio, visualCard);
      return;
    }

    var nativeLabel = event.target.closest(CARD_SELECTOR + ' .color-swatch__item');
    if (!nativeLabel) return;
    var nativeCard = nativeLabel.closest(CARD_SELECTOR);
    var nativeId = nativeLabel.getAttribute('for');
    var nativeRadio = nativeId ? document.getElementById(nativeId) : null;
    if (nativeCard && nativeRadio) preloadRadioImage(nativeRadio, nativeCard);
  }, { capture: true, passive: true });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('color-swatch__radio')) return;
    var card = target.closest && target.closest(CARD_SELECTOR);
    if (!card) return;

    syncVisual(card);
    groupPriceAndUnit(card);
    normalizeCta(card);
    [0,80,180].forEach(function (delay) {
      window.setTimeout(function () {
        syncVisual(card);
        groupPriceAndUnit(card);
        normalizeCta(card);
      }, delay);
    });
  }, true);

  document.addEventListener('shopify:section:load', processAll);
  document.addEventListener('theme:loading:end', processAll);
  window.addEventListener('popstate', processAll);
  window.addEventListener('resize', function () {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      refreshLoopSpeeds();
    });
  }, { passive: true });

  if (mobile.addEventListener) mobile.addEventListener('change', function (event) { if (event.matches) processAll(); });
  else if (mobile.addListener) mobile.addListener(function (event) { if (event.matches) processAll(); });
})();
